import { EstudioDTO, PanelDTO } from "@DTOS";

export class PanelUtils {
    static aEstudio(panel: PanelDTO): EstudioDTO {
        const estudio = new EstudioDTO();

        estudio.id = panel.id;
        estudio.ultimaCorrida = panel.ultimaCorrida;
        estudio.tipo = panel.tipo;
        estudio.marca = panel.marca;
        estudio.estado = panel.estado;
        estudio.panel = panel;

        return estudio;
    }
}
